/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js');
var spine_core_user_id_pb = require('../../spine/core/user_id_pb.js');
var spine_core_actor_context_pb = require('../../spine/core/actor_context_pb.js');
var spine_core_response_pb = require('../../spine/core/response_pb.js');
var spine_client_entities_pb = require('../../spine/client/entities_pb.js');
goog.exportSymbol('proto.spine.client.OrderBy', null, global);
goog.exportSymbol('proto.spine.client.OrderBy.Direction', null, global);
goog.exportSymbol('proto.spine.client.Pagination', null, global);
goog.exportSymbol('proto.spine.client.Query', null, global);
goog.exportSymbol('proto.spine.client.QueryId', null, global);
goog.exportSymbol('proto.spine.client.QueryResponse', null, global);
goog.exportSymbol('proto.spine.client.QueryValidationError', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.QueryId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.QueryId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.QueryId.displayName = 'proto.spine.client.QueryId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.QueryId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.QueryId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.QueryId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.QueryId.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.QueryId}
 */
proto.spine.client.QueryId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.QueryId;
  return proto.spine.client.QueryId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.QueryId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.QueryId}
 */
proto.spine.client.QueryId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.QueryId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.QueryId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.QueryId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.QueryId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.spine.client.QueryId.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.client.QueryId.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.OrderBy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.OrderBy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.OrderBy.displayName = 'proto.spine.client.OrderBy';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.OrderBy.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.OrderBy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.OrderBy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.OrderBy.toObject = function(includeInstance, msg) {
  var f, obj = {
    direction: jspb.Message.getFieldWithDefault(msg, 1, 0),
    column: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.OrderBy}
 */
proto.spine.client.OrderBy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.OrderBy;
  return proto.spine.client.OrderBy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.OrderBy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.OrderBy}
 */
proto.spine.client.OrderBy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.spine.client.OrderBy.Direction} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.OrderBy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.OrderBy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.OrderBy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.OrderBy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getColumn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.spine.client.OrderBy.Direction = {
  OD_UNKNOWN: 0,
  ASCENDING: 1,
  DESCENDING: 2
};

/**
 * optional Direction direction = 1;
 * @return {!proto.spine.client.OrderBy.Direction}
 */
proto.spine.client.OrderBy.prototype.getDirection = function() {
  return /** @type {!proto.spine.client.OrderBy.Direction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.spine.client.OrderBy.Direction} value */
proto.spine.client.OrderBy.prototype.setDirection = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string column = 2;
 * @return {string}
 */
proto.spine.client.OrderBy.prototype.getColumn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.spine.client.OrderBy.prototype.setColumn = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.Pagination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.Pagination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.Pagination.displayName = 'proto.spine.client.Pagination';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.Pagination.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.Pagination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.Pagination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Pagination.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.Pagination}
 */
proto.spine.client.Pagination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.Pagination;
  return proto.spine.client.Pagination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.Pagination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.Pagination}
 */
proto.spine.client.Pagination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.Pagination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.Pagination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.Pagination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Pagination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 page_size = 1;
 * @return {number}
 */
proto.spine.client.Pagination.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.spine.client.Pagination.prototype.setPageSize = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.Query = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.Query, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.Query.displayName = 'proto.spine.client.Query';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.Query.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.Query.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.Query} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Query.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.spine.client.QueryId.toObject(includeInstance, f),
    target: (f = msg.getTarget()) && spine_client_entities_pb.Target.toObject(includeInstance, f),
    fieldMask: (f = msg.getFieldMask()) && google_protobuf_field_mask_pb.FieldMask.toObject(includeInstance, f),
    context: (f = msg.getContext()) && spine_core_actor_context_pb.ActorContext.toObject(includeInstance, f),
    orderby: (f = msg.getOrderby()) && proto.spine.client.OrderBy.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && proto.spine.client.Pagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.Query}
 */
proto.spine.client.Query.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.Query;
  return proto.spine.client.Query.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.Query} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.Query}
 */
proto.spine.client.Query.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.client.QueryId;
      reader.readMessage(value,proto.spine.client.QueryId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_client_entities_pb.Target;
      reader.readMessage(value,spine_client_entities_pb.Target.deserializeBinaryFromReader);
      msg.setTarget(value);
      break;
    case 3:
      var value = new google_protobuf_field_mask_pb.FieldMask;
      reader.readMessage(value,google_protobuf_field_mask_pb.FieldMask.deserializeBinaryFromReader);
      msg.setFieldMask(value);
      break;
    case 4:
      var value = new spine_core_actor_context_pb.ActorContext;
      reader.readMessage(value,spine_core_actor_context_pb.ActorContext.deserializeBinaryFromReader);
      msg.setContext(value);
      break;
    case 5:
      var value = new proto.spine.client.OrderBy;
      reader.readMessage(value,proto.spine.client.OrderBy.deserializeBinaryFromReader);
      msg.setOrderby(value);
      break;
    case 6:
      var value = new proto.spine.client.Pagination;
      reader.readMessage(value,proto.spine.client.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.Query.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.Query.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.Query} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Query.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.client.QueryId.serializeBinaryToWriter
    );
  }
  f = message.getTarget();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_client_entities_pb.Target.serializeBinaryToWriter
    );
  }
  f = message.getFieldMask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_field_mask_pb.FieldMask.serializeBinaryToWriter
    );
  }
  f = message.getContext();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      spine_core_actor_context_pb.ActorContext.serializeBinaryToWriter
    );
  }
  f = message.getOrderby();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.spine.client.OrderBy.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.spine.client.Pagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional QueryId id = 1;
 * @return {?proto.spine.client.QueryId}
 */
proto.spine.client.Query.prototype.getId = function() {
  return /** @type{?proto.spine.client.QueryId} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.QueryId, 1));
};


/** @param {?proto.spine.client.QueryId|undefined} value */
proto.spine.client.Query.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.client.Query.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Query.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Target target = 2;
 * @return {?proto.spine.client.Target}
 */
proto.spine.client.Query.prototype.getTarget = function() {
  return /** @type{?proto.spine.client.Target} */ (
    jspb.Message.getWrapperField(this, spine_client_entities_pb.Target, 2));
};


/** @param {?proto.spine.client.Target|undefined} value */
proto.spine.client.Query.prototype.setTarget = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.client.Query.prototype.clearTarget = function() {
  this.setTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Query.prototype.hasTarget = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.FieldMask field_mask = 3;
 * @return {?proto.google.protobuf.FieldMask}
 */
proto.spine.client.Query.prototype.getFieldMask = function() {
  return /** @type{?proto.google.protobuf.FieldMask} */ (
    jspb.Message.getWrapperField(this, google_protobuf_field_mask_pb.FieldMask, 3));
};


/** @param {?proto.google.protobuf.FieldMask|undefined} value */
proto.spine.client.Query.prototype.setFieldMask = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.client.Query.prototype.clearFieldMask = function() {
  this.setFieldMask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Query.prototype.hasFieldMask = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional spine.core.ActorContext context = 4;
 * @return {?proto.spine.core.ActorContext}
 */
proto.spine.client.Query.prototype.getContext = function() {
  return /** @type{?proto.spine.core.ActorContext} */ (
    jspb.Message.getWrapperField(this, spine_core_actor_context_pb.ActorContext, 4));
};


/** @param {?proto.spine.core.ActorContext|undefined} value */
proto.spine.client.Query.prototype.setContext = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.spine.client.Query.prototype.clearContext = function() {
  this.setContext(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Query.prototype.hasContext = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional OrderBy orderBy = 5;
 * @return {?proto.spine.client.OrderBy}
 */
proto.spine.client.Query.prototype.getOrderby = function() {
  return /** @type{?proto.spine.client.OrderBy} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.OrderBy, 5));
};


/** @param {?proto.spine.client.OrderBy|undefined} value */
proto.spine.client.Query.prototype.setOrderby = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.spine.client.Query.prototype.clearOrderby = function() {
  this.setOrderby(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Query.prototype.hasOrderby = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Pagination pagination = 6;
 * @return {?proto.spine.client.Pagination}
 */
proto.spine.client.Query.prototype.getPagination = function() {
  return /** @type{?proto.spine.client.Pagination} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.Pagination, 6));
};


/** @param {?proto.spine.client.Pagination|undefined} value */
proto.spine.client.Query.prototype.setPagination = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.spine.client.Query.prototype.clearPagination = function() {
  this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Query.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.QueryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.client.QueryResponse.repeatedFields_, null);
};
goog.inherits(proto.spine.client.QueryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.QueryResponse.displayName = 'proto.spine.client.QueryResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.client.QueryResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.QueryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.QueryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.QueryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.QueryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    response: (f = msg.getResponse()) && spine_core_response_pb.Response.toObject(includeInstance, f),
    messagesList: jspb.Message.toObjectList(msg.getMessagesList(),
    google_protobuf_any_pb.Any.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.QueryResponse}
 */
proto.spine.client.QueryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.QueryResponse;
  return proto.spine.client.QueryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.QueryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.QueryResponse}
 */
proto.spine.client.QueryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_response_pb.Response;
      reader.readMessage(value,spine_core_response_pb.Response.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 5:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.addMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.QueryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.QueryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.QueryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.QueryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_response_pb.Response.serializeBinaryToWriter
    );
  }
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.Response response = 1;
 * @return {?proto.spine.core.Response}
 */
proto.spine.client.QueryResponse.prototype.getResponse = function() {
  return /** @type{?proto.spine.core.Response} */ (
    jspb.Message.getWrapperField(this, spine_core_response_pb.Response, 1));
};


/** @param {?proto.spine.core.Response|undefined} value */
proto.spine.client.QueryResponse.prototype.setResponse = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.client.QueryResponse.prototype.clearResponse = function() {
  this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.QueryResponse.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated google.protobuf.Any messages = 5;
 * @return {!Array<!proto.google.protobuf.Any>}
 */
proto.spine.client.QueryResponse.prototype.getMessagesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Any>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_any_pb.Any, 5));
};


/** @param {!Array<!proto.google.protobuf.Any>} value */
proto.spine.client.QueryResponse.prototype.setMessagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.google.protobuf.Any=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Any}
 */
proto.spine.client.QueryResponse.prototype.addMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.google.protobuf.Any, opt_index);
};


proto.spine.client.QueryResponse.prototype.clearMessagesList = function() {
  this.setMessagesList([]);
};


/**
 * @enum {number}
 */
proto.spine.client.QueryValidationError = {
  QVE_UNKNOWN_REASON: 0,
  UNSUPPORTED_QUERY_TARGET: 1,
  INVALID_QUERY: 2
};

goog.object.extend(exports, proto.spine.client);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');

proto.spine.client.QueryId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.QueryId.fromObject(jsObject);
};

proto.spine.client.QueryId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.QueryId();
  
  if (obj.value !== undefined) {
    if (obj.value !== null) {
      let value = obj.value;
      msg.setValue(value);
    }
  }
  return msg;
};

proto.spine.client.OrderBy.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.OrderBy.fromObject(jsObject);
};

proto.spine.client.OrderBy.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.OrderBy();
  
  if (obj.direction !== undefined) {
    if (obj.direction !== null) {
      let value = proto.spine.client.OrderBy.Direction[obj.direction];
      msg.setDirection(value);
    }
  }
  
  if (obj.column !== undefined) {
    if (obj.column !== null) {
      let value = obj.column;
      msg.setColumn(value);
    }
  }
  return msg;
};

proto.spine.client.Pagination.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.Pagination.fromObject(jsObject);
};

proto.spine.client.Pagination.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.Pagination();
  
  if (obj.pageSize !== undefined) {
    if (obj.pageSize !== null) {
      let value = obj.pageSize;
      msg.setPageSize(value);
    }
  }
  return msg;
};

proto.spine.client.Query.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.Query.fromObject(jsObject);
};

proto.spine.client.Query.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.Query();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.client.QueryId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.target !== undefined) {
    if (obj.target === null) {
      msg.setTarget(null);
    } else {
      let value = proto.spine.client.Target.fromObject(obj.target);
      msg.setTarget(value);
    }
  }
  
  if (obj.fieldMask !== undefined) {
    if (obj.fieldMask === null) {
      msg.setFieldMask(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.FieldMask');
      let value = parser.parse(obj.fieldMask);
      msg.setFieldMask(value);
    }
  }
  
  if (obj.context !== undefined) {
    if (obj.context === null) {
      msg.setContext(null);
    } else {
      let value = proto.spine.core.ActorContext.fromObject(obj.context);
      msg.setContext(value);
    }
  }
  
  if (obj.orderBy !== undefined) {
    if (obj.orderBy === null) {
      msg.setOrderBy(null);
    } else {
      let value = proto.spine.client.OrderBy.fromObject(obj.orderBy);
      msg.setOrderBy(value);
    }
  }
  
  if (obj.pagination !== undefined) {
    if (obj.pagination === null) {
      msg.setPagination(null);
    } else {
      let value = proto.spine.client.Pagination.fromObject(obj.pagination);
      msg.setPagination(value);
    }
  }
  return msg;
};

proto.spine.client.QueryResponse.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.QueryResponse.fromObject(jsObject);
};

proto.spine.client.QueryResponse.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.QueryResponse();
  
  if (obj.response !== undefined) {
    if (obj.response === null) {
      msg.setResponse(null);
    } else {
      let value = proto.spine.core.Response.fromObject(obj.response);
      msg.setResponse(value);
    }
  }
  
  if (obj.messages !== undefined && obj.messages !== null) {
    obj.messages.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addMessages(null);
        } else {
          let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
          let value = parser.parse(listItem);
          msg.addMessages(value);
        }
      }
    );
  }
  return msg;
};
